import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: 'PLATFORM', to: '/#pipeline', type: 'hash' },
  { label: 'CASE STUDIES', to: '/case-studies', type: 'route' },
  { label: 'CALCULATOR', to: '/calculator', type: 'route' },
  { label: 'PRICING', to: '/pricing', type: 'route' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.classList.toggle('menu-open', open);
    return () => document.body.classList.remove('menu-open');
  }, [open]);

  const handleHash = (item) => (e) => {
    if (item.type === 'hash' && location.pathname === '/') {
      e.preventDefault();
      const id = item.to.split('#')[1];
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
      setOpen(false);
    }
  };

  const closeMenu = () => setOpen(false);

  return (
    <header
      className={`sticky top-0 z-50 transition-colors duration-200 ${
        scrolled ? 'bg-[#050505]/90 backdrop-blur border-b border-[#1a1a1a]' : 'bg-transparent'
      }`}
      data-testid="site-header"
    >
      <div className="container-r360 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
          <img
            src={`${process.env.PUBLIC_URL}/img/main-logo.png`}
            alt="Retarget360.ai logo"
            className="h-10 w-auto"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-4 xl:gap-8" aria-label="Primary">
          {navItems.map((item) => {
            const testId = `nav-${item.label.toLowerCase().replace(/ /g, '-')}`;
            if (item.type === 'route') {
              return (
                <Link
                  key={item.label}
                  to={item.to}
                  className="menu-link text-[#c9c9c9] hover:text-white transition-colors"
                  data-testid={testId}
                >
                  {item.label}
                </Link>
              );
            }
            return (
              <a
                key={item.label}
                href={item.to}
                onClick={handleHash(item)}
                className="menu-link text-[#c9c9c9] hover:text-white transition-colors"
                data-testid={testId}
              >
                {item.label}
              </a>
            );
          })}
        </nav>

        <div className="flex items-center gap-3">
          <Link to="/book-a-demo" className="btn btn-primary book-btn md:inline-flex" data-testid="nav-book-demo">
            Book a Demo →
          </Link>
          <button
            onClick={() => setOpen((o) => !o)}
            className={`hamburger-button lg:hidden ${open ? 'is-open' : ''}`}
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
            aria-controls="mobile-menu-overlay"
            data-testid="menu-toggle"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>

      <div
        id="mobile-menu-overlay"
        className={`mobile-menu-overlay lg:hidden ${open ? 'is-open' : ''}`}
        aria-hidden={!open}
      >
        <div className="mobile-menu-panel">
          <nav className="mobile-menu-nav" aria-label="Mobile primary">
            {navItems.map((item) => {
              if (item.type === 'route') {
                return (
                  <Link key={item.label} to={item.to} onClick={closeMenu} className="mobile-menu-link">
                    {item.label}
                  </Link>
                );
              }
              return (
                <a key={item.label} href={item.to} onClick={handleHash(item)} className="mobile-menu-link">
                  {item.label}
                </a>
              );
            })}
            <Link to="/book-a-demo" onClick={closeMenu} className="btn btn-primary mobile-menu-cta">
              Book a Demo →
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}
